import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;
const hdrs = () => ({ headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
const unwrap = (d) => (Array.isArray(d) ? d : d?.$values ?? []);

const PropertyService = {
  createProperty: (data) =>
    axios.post(`${BASE}/Property/CreateProperty`, data, hdrs()).then((r) => r.data),

  getPropertyById: (id) =>
    axios.get(`${BASE}/Property/GetPropertyById/${id}`, hdrs()).then((r) => r.data),

  getPropertiesByClientId: (clientId) =>
    axios.get(`${BASE}/Property/GetPropertiesByClientId/${clientId}`, hdrs()).then((r) => unwrap(r.data)),

  updateProperty: (id, data) =>
    axios.put(`${BASE}/Property/UpdateProperty/${id}`, data, hdrs()).then((r) => r.data),

  updatePropertyStatus: (id, status) =>
    axios.put(`${BASE}/Property/UpdateStatus/${id}`, null, { ...hdrs(), params: { status } }).then((r) => r.data),

  deleteProperty: (id) =>
    axios.delete(`${BASE}/Property/DeleteProperty/${id}`, hdrs()).then((r) => r.data),

  getStats: (clientId) =>
    axios.get(`${BASE}/Property/Stats/${clientId}`, hdrs()).then((r) => r.data),
};

export default PropertyService;
